import useContryCurrencyHook from "../../../hooks/useCountryCurrencyList.ts";
import React from "react";
import { FilterOption } from "../FilterPopover.types.ts";
import SubMenuList from "./SubMenuList.tsx";
import { GetListData } from "./SubMenuDataHelper.ts";

export interface CurrencySubMenuProps {
    selectedOption: FilterOption;
    onChange: (currencies: Array<string>) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef: React.RefObject<HTMLInputElement>;
}

function CurrencySubMenu(props: CurrencySubMenuProps) {
    const { selectedOption, onChange, onLeftArrowClick, submenuInputRef } = props;

    let chosenValues: Array<string> = GetListData(selectedOption.value);

    const { getCurrenciesAsNames } = useContryCurrencyHook();
    const currencies = getCurrenciesAsNames();

    return (
        <SubMenuList
            separateListForSelectedValue
            submenuInputRef={submenuInputRef}
            data={currencies}
            onLeftArrowClick={onLeftArrowClick}
            chosenValues={chosenValues.map((x) => {
                return { id: x, name: currencies.find((y) => y.id == x)!.name };
            })}
            onChange={(chosenOption) => {
                if (chosenValues.includes(chosenOption.id)) {
                    onChange(chosenValues.filter((x) => x !== chosenOption.id));
                } else {
                    const newChosenValues = [...chosenValues, chosenOption.id];
                    onChange(newChosenValues);
                }
            }}
        />
    );
}

export default CurrencySubMenu;
